import { useEffect, useState } from "react";
import { Menu, X, Mail } from "lucide-react";
import { NAV_ITEMS, CONTACT } from "@/data/content";

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-background/75 border-b border-border/60"
                    : "bg-transparent"
            }`}
        >
            <div className="container-em flex items-center justify-between h-16 md:h-20">
                <a
                    href="#top"
                    data-testid="navbar-logo"
                    className="flex items-center gap-2 group"
                >
                    <span className="font-display text-2xl md:text-3xl tracking-tight text-foreground">
                        Emsglück
                    </span>
                    <span
                        aria-hidden
                        className="hidden sm:inline-block h-1.5 w-1.5 rounded-full bg-primary transition-all duration-500 group-hover:w-6"
                    />
                </a>

                <nav className="hidden md:flex items-center gap-8">
                    {NAV_ITEMS.map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            data-testid={`navbar-link-${item.href.slice(1)}`}
                            className="text-sm text-foreground/70 hover:text-foreground transition-colors font-medium"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <div className="hidden md:flex items-center gap-3">
                    <a
                        href="#anfrage"
                        data-testid="navbar-inquiry-button"
                        className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-medium hover:bg-primary/90 transition-all duration-300 hover:-translate-y-0.5 shadow-sm hover:shadow-md"
                    >
                        <Mail size={16} />
                        Unverbindlich anfragen
                    </a>
                </div>

                <button
                    className="md:hidden p-2 -mr-2 text-foreground"
                    onClick={() => setOpen((s) => !s)}
                    aria-label={open ? "Menü schließen" : "Menü öffnen"}
                    data-testid="navbar-toggle"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {/* Mobile menu */}
            {open && (
                <div
                    className="md:hidden border-t border-border/60 bg-background/95 backdrop-blur-xl"
                    data-testid="navbar-mobile-menu"
                >
                    <div className="container-em py-6 flex flex-col gap-4">
                        {NAV_ITEMS.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                onClick={() => setOpen(false)}
                                className="text-base text-foreground/80 hover:text-foreground py-2"
                            >
                                {item.label}
                            </a>
                        ))}
                        <a
                            href="#anfrage"
                            onClick={() => setOpen(false)}
                            data-testid="navbar-inquiry-button-mobile"
                            className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-3 text-sm font-medium"
                        >
                            <Mail size={16} />
                            Unverbindlich anfragen
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
